(() => {
  const text = window.bisNotifyText;
  const animation = window.bisButtonAnimation;

  function wrapWithButtonContent(span) {
    if (span.closest("button-content")) return;

    const wrapper = document.createElement("button-content");
    wrapper.className = "button__content";

    if (animation === "rotation")
      wrapper.setAttribute("rotated-text", span.textContent.trim());
    else if (animation === "up")
      wrapper.setAttribute("up-text", span.textContent.trim());
    else if (animation === "glowing") wrapper.setAttribute("glowing", "");

    span.replaceWith(wrapper);
    wrapper.appendChild(span);
  }

  function processAll() {
    for (const el of document.querySelectorAll(".wcBsiNotifyText")) {
      if (text && el.textContent.trim() !== text) {
        el.textContent = text;
        const existing = el.closest("button-content");
        if (existing) {
          if (animation === "rotation")
            existing.setAttribute("rotated-text", text);
          else if (animation === "up") existing.setAttribute("up-text", text);
        }
      }

      wrapWithButtonContent(el);

      const btn = el.closest('button, a');
      if (btn && !btn.classList.contains('button')) btn.classList.add('button');

      const bisWrapper = el.closest('.wc_wl_bis_btn');
      if (bisWrapper?.hasAttribute('hidden')) {
        setTimeout(() => {
          bisWrapper.removeAttribute('hidden');
          const placeholder = bisWrapper.previousElementSibling;
          if (placeholder?.hasAttribute('data-bis-placeholder')) {
            placeholder.style.display = 'none';
          }
        }, 0);
      }
    }
  }

  const observer = new MutationObserver(processAll);
  observer.observe(document.body, { childList: true, subtree: true });

  processAll();
})();
